import { Injectable } from '@angular/core';
import { Http, Jsonp } from '@angular/http';
import 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { VersionService } from '../services/version.service';
import { Config } from '../classes/config';

@Injectable()
export class ProgramService {

  constructor(private _http: Http, private _jsonp: Jsonp, private ver: VersionService) { }

  get() {
    return this._http.get(`${Config.apiUrl}/Programma?versionId=${this.ver.activeVersion()}&jsonp=true&top=8&q=&callback=JSONP_CALLBACK`)
      .map(resp => resp.json());
  }

  getProgram(id: number) {
    return this._http.get(
      `${Config.apiUrl}/Programma?versionId=${this.ver.activeVersion()}&jsonp=true&top=8&id=${id.toString()}&q=&callback=JSONP_CALLBACK`
    ).map(resp => resp.json()[0]);
  }

  getFullProgram(id: number) {
    return this._http.get(
      `${Config.apiUrl}/Programma?versionId=${this.ver.activeVersion()}&full=1&jsonp=true&top=8&id=${id.toString()}&q=&callback=JSONP_CALLBACK`
    ).map(resp => resp.json()[0]);
  }

  getTargets(programId: number) {
    return this._http.get(
      `${Config.apiUrl}/Thema?versionId=${this.ver.activeVersion()}&targets=1&q=&programma=${programId.toString()}&q=&callback=JSONP_CALLBACK`
    ).map(resp => resp.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/services/program.service.ts